import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  public forgotPasswordForm: FormGroup;
  public isAuthLoading = false;
  public env = environment.forntend_url;

  constructor(public formBuilder: FormBuilder, public router: Router) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required]],
    });
  }

  ngOnDestroy(): void {}

  get formData() {
    return this.forgotPasswordForm.controls;
  }

  /**
   * @name submit
   * @description This method is used to verify email for recover password
   * @param none
   * @return none
   */

  submit() {
    this.router.navigate(['/recover-password']);
  }
}
